import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet'

type MainProps = PropsWithChildren<{
  title?: string
}>

const Main = ({ title, children }: MainProps) => {
  return (
    <main className='flex-1'>
      <Helmet>
        <title>{[title, 'wowaudit'].filter(Boolean).join(' | ')}</title>
      </Helmet>
      <div className='root-width max-sm:px-4 mt-8 mb-10'>{children}</div>
    </main>
  )
}

export default Main
